import { DEFAULT_CLIDS, UNKNOWN_CLID } from '@/constants/general'

type ResolveClidOptions = {
    host?: string
    landingClid?: string
    queryClid?: string
}

export function resolveClid({ host, landingClid, queryClid }: ResolveClidOptions): string {
    if (typeof queryClid === 'string' && queryClid) {
        return queryClid
    }

    if (landingClid) {
        return landingClid
    }

    if (host === 'playgama.com') {
        return DEFAULT_CLIDS.direct
    }

    if (host?.endsWith('.playgama.com')) {
        return DEFAULT_CLIDS.directTest
    }

    return UNKNOWN_CLID
}
